import React from "react";
import { Layout } from "antd";

import "./footer.less";

export class FooterBar extends React.Component {
  render() {
    return (
      <Layout.Footer className='footer'>
        Nowd ©2020
      </Layout.Footer>
    );
  }
}
